import { Grid, Typography } from "@mui/material";
import React from "react";
import "./styles.scss";

const GoalItem = ({ onClick, name, image }) => {
  return (
    <Grid
      item
      xs={2}
      sm={4}
      md={6}
      onClick={onClick}
      sx={{
        marginBottom: "8px",
      }}
      data-cy={`goal-${name}`}
    >
      <img src={image} alt={name} className="goal-image" />
      <Typography
        color="textPrimary"
        sx={{
          marginTop: "8px",
          flexGrow: 0,
          fontFamily: "FSElliotPro",
          fontSize: "16px",
          fontWeight: "700",
          lineHeight: 1.5,
          textTransform: "capitalize",
          textAlign: "center",
        }}
      >
        {name}
      </Typography>
    </Grid>
  );
};

export default GoalItem;
